<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-glass-shop-orders">

        <page-title :title="'Szkło'" :back="false"></page-title>

        <shop-glass-segment :value="'ShopGlassOrders'"></shop-glass-segment>

        <div v-for="(item,index) in orders" :key="item.slug">
            <item-glass-order
                    :index="index+1"
                    :slug="item.slug"
                    :badge="item.badge"
                    :title="item.title"
                    :content="item.content"
                    :price="item.price"
                    :disabled="item.disabled">
            </item-glass-order>
        </div>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import ItemGlassOrder from '@/items/ItemGlassOrder';
    import ShopGlassSegment from '@/navs/ShopGlassSegment';

    export default {
        name: 'ShopGlassOrders',
        components: { PageTitle, ItemGlassOrder, ShopGlassSegment },
        data() {
            return {
                orders: [
                    {
                        slug: 'test-0',
                        badge: 'Przyjęte',
                        title: 'Zamówienie nr 774',
                        content: '<p>Z dnia: 04.02.2020, 16:52</p>',
                        price: '55,35',
                        disabled: false
                    },
                    {
                        slug: 'test-1',
                        badge: 'Anulowane',
                        title: 'Zamówienie nr 612',
                        content: '<p>Z dnia: 24.01.2018, 16:52</p>',
                        price: '626,90',
                        disabled: true
                    },
                ]
            }
        }
    }
</script>